import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { Translate as translate } from '@wsb/vnext-widget-content-translate';
import dataAids from '../constants/dataAids';

const styles = {
  form: {
    marginBottom: 'large'
  },

  inputBlock: {
    marginBottom: 'medium'
  },

  label: {
    display: 'inline-block',
    marginBottom: 'xxsmall'
  }
};

const isErrorMessageVisible = (error, question) => {
  if (!error) return false;

  const { type, data = {} } = error;
  return type === 'blank_answer' && data.question_id === question.id;
};

const findStoredAnswer = (questionId, answers = []) => {
  const answer = answers.find(answr => answr.questionId === questionId);
  return answer ? answer.body : null;
};

const QuestionsForm = ({
  answers,
  error,
  maxAnswerLength,
  onAnswerQuestions,
  questions,
  staticContent,
  titleStyles
}) => {
  const {
    Element: { Block, Heading, Input, Label, Error },
    Group: { Form }
  } = UX2;

  const interpolate = translate(staticContent);

  return (
    <Block style={ styles.form }>
      <Heading.Minor style={ titleStyles }>{ staticContent.additionalInformation }</Heading.Minor>

      <Form data-aid={ dataAids.BOOKING_QUESTIONS }>
        { questions.map(question => (
          <Block key={ question.id } style={ styles.inputBlock }>
            <Label style={ styles.label } for={ `question-${question.id}` }>
              { question.required
                ? question.body
                : interpolate('questionOptional', { body: question.body }) }
            </Label>

            <Input
              id={ `question-${question.id}` }
              maxLength={ maxAnswerLength }
              onChange={ e => onAnswerQuestions(question.id, e.target.value) }
              value={ findStoredAnswer(question.id, answers) }
            />

            { isErrorMessageVisible(error, question) && (
              <Error data-aid={ dataAids.BOOKING_FORM_QUESTION_VALIDATION_ERROR }>
                { staticContent.questionValidationError }
              </Error>
            ) }
          </Block>
        )) }
      </Form>
    </Block>
  );
};

QuestionsForm.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      question_id: PropTypes.number,
      body: PropTypes.string
    })
  ),
  error: PropTypes.object,
  maxAnswerLength: PropTypes.number,
  onAnswerQuestions: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      body: PropTypes.string.isRequired,
      required: PropTypes.bool.isRequired
    })
  ).isRequired,
  staticContent: PropTypes.object.isRequired,
  titleStyles: PropTypes.object
};

QuestionsForm.defaultProps = {
  answers: [],
  questions: []
};

export default QuestionsForm;
